<template>
	<Index />
</template>

<script>
	import Index from "@/pages/Index.vue";

	export default {
		name: 'App',
		components: {
			Index
		}
	}
</script>

<style>
	html,
	body {
		margin: 0;
		padding: 0;
	}
</style>